<template>
  <div class="change-password">
    <div class="mdl-card mdl-shadow--2dp" v-if="state == 'done'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n().done.title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">
        {{ i18n().done.text }}
      </div>
    </div>
    <form class="mdl-card mdl-shadow--2dp" v-on:submit="change" v-if="state != 'done'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div :class="{blurred: state=='working'}">
          <div class="serverError" v-if="error">{{ i18n().errors[error] || error }}</div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="oldPassword" v-model="oldPassword"
                   v-bind:required="required" ref="oldPassword">
            <label class="mdl-textfield__label" for="oldPassword">{{ i18n().oldPassword }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword1" v-model="newPassword1"
                   v-bind:required="required" ref="newPassword1">
            <label class="mdl-textfield__label" for="newPassword1">{{ i18n().newPassword }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword2" v-model="newPassword2"
                   v-bind:required="required" ref="newPassword2">
            <label class="mdl-textfield__label" for="newPassword2">{{ i18n().retypePassword }}</label>
            <span v-if="notMatch" class="mdl-textfield__error">{{ i18n().notMatch }}</span>
          </div>

        </div>

        <div class="working" v-if="state == 'working'">
          <div class="mdl-spinner mdl-js-spinner is-active"></div>
        </div>

      </div>

      <div class="mdl-card__actions mdl-card--border" :class="{blurred: state=='working'}">
        <button type="submit" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n().submit }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import api from "api"
  import i18n from "i18n"

  export default {
    name: 'change-password',
    data () {
      return {
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
        state: 'ready',
        required: false,
        notMatch: false,
        error: null
      }
    },
    methods: {
      i18n() { return i18n().emailPassword.changePassword },
      change(e) {
        e.preventDefault()

        if(this.oldPassword.trim() == '' || this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
          this.required = true
          if(this.newPassword2.trim()=='') {
            this.$refs.newPassword2.parentElement.setAttribute('class',
              this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.newPassword2.focus()
          }
          if(this.newPassword1.trim()=='') {
            this.$refs.newPassword1.parentElement.setAttribute('class',
              this.$refs.newPassword1.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.newPassword1.focus()
          }
          if(this.oldPassword.trim()=='') {
            this.$refs.oldPassword.parentElement.setAttribute('class',
              this.$refs.oldPassword.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.oldPassword.focus()
          }
          return
        }

        this.notMatch = (this.newPassword1 != this.newPassword2)
        if(this.notMatch) {
          this.$refs.newPassword2.parentElement.setAttribute('class',
            this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.newPassword2.focus()
          return;
        }

        this.state = "working"
        logger.addPassword(this.oldPassword)
        logger.addPassword(this.newPassword1)
        api.request(["emailPassword", "updatePasswords"], this.oldPassword, this.newPassword1).then(result => {
          logger.removePassword(this.oldPassword)
          logger.removePassword(this.newPassword1)
          this.state = "done"
        }).catch(error => {
          logger.removePassword(this.oldPassword)
          logger.removePassword(this.newPassword1)
          this.error = error
          this.state = "ready"
        })
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .change-password {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .mdl-card__actions button {
    float: right;
  }

  .blurred {
    filter: blur(2px) grayscale(50%);
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .serverError {
    color: darkred;
  }

</style>



// WEBPACK FOOTER //
// ChangePassword.vue?dc3ee50c